var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 60,
    viewBox: "0 0 38 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2729 3.81249L10.2729 3.81251L33.1933 26.7322C33.1933 26.7322 33.1933 26.7322 33.1933 26.7322C34.9433 28.4822 34.9433 31.4426 33.1933 33.1926L10.1733 56.2126C10.1731 56.2128 10.173 56.2129 10.1728 56.2131C9.36542 57.0197 8.09982 57.5 6.993 57.5C5.85603 57.5 4.70179 57.1017 3.81321 56.2131C2.06323 54.4631 2.06323 51.5027 3.81321 49.7527L3.81324 49.7526L21.7847 31.7805L23.5524 30.0127L21.7846 28.245L3.81249 10.2729C2.06251 8.52289 2.0625 5.56247 3.81249 3.81249C5.56247 2.0625 8.52289 2.06251 10.2729 3.81249Z",
    fill: "#212121",
    fillOpacity: 0.25,
    stroke: "#FAF9FA",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayRightArrow);
export default __webpack_public_path__ + "static/media/grayRightArrow.ed9a6c5108ec12b23db06511ea95de92.svg";
export { ForwardRef as ReactComponent };